import Page from './containers/Page.jsx';

export default Page;
